import { AxiosError, AxiosInstance } from 'axios'

export type ApiErrorHandler = (error: AxiosError) => void
type ErrorType = string
export type ErrorHandlers = Record<ErrorType, ApiErrorHandler>

export interface InterceptorManager {
  setErrorHandlers(handlers: ErrorHandlers, defaultHandler?: ApiErrorHandler): void
  registerInstance(instance: AxiosInstance): void
  getErrorHandlers(): ErrorHandlers
  getDefaultErrorHandler(): ApiErrorHandler | null
  getRegisteredInstances(): Set<AxiosInstance>
}

export function createInterceptorManager(): InterceptorManager {
  let errorHandlers: ErrorHandlers = {}
  let defaultErrorHandler: ApiErrorHandler | null = null
  const registeredInstances = new Set<AxiosInstance>()

  return {
    setErrorHandlers(handlers: ErrorHandlers, defaultHandler?: ApiErrorHandler) {
      errorHandlers = handlers
      defaultErrorHandler = defaultHandler || null
    },

    registerInstance(instance: AxiosInstance) {
      if (registeredInstances.has(instance)) {
        return
      }

      registeredInstances.add(instance)
    },

    getErrorHandlers: () => errorHandlers,
    getDefaultErrorHandler: () => defaultErrorHandler,
    getRegisteredInstances: () => new Set(registeredInstances)
  }
}

export const interceptorManager = createInterceptorManager()
